import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { BulkAccountVerificationStatus } from "../../../config/chip/chipConfig.js";
import { MemoizedChip, MemoizedDefaultChip } from "../../../components/chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../../../components/chip/types.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { AccountVerificationStatus, FeatureAccessStatus } from "../../../contract/pam.js";
import "@apollo/client";
import "immer";
import "rxjs";
import "../../../api/types.js";
import "moment-timezone";
import "@apollo/client/errors";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "@automapper/core";
import "date-fns";
import { lockReasonOptions } from "../../user-profile/constants.js";
import "react-redux";
import "../../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../../auto-mapper/AutoMapperProvider.js";
import "../../../redux-folder/async-actions/actions.js";
import "../../../redux-folder/async-actions/selectors.js";
import "../../../intl/shared-resources/serverResponse.js";
import "typesafe-actions";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "../../../redux-folder/async-actions/reducers.js";
import "../../../redux-folder/download/actions.js";
import "../../../redux-folder/download/epics.js";
import "../../../ioc-container/inversifyProvider.js";
import "react-hook-form";
import "fast-deep-equal";
import "normalizr";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "../../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "../../user-profile/components/DataGrid.js";
import "../../user-profile/actions.js";
import "../../user-profile/epics.js";
import "../../user-profile/components/Platform.js";
import "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import "../../../components/filter/FilterGroupNew.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import "../../brand-license/constants.js";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import "../../user-profile/components/Filters.js";
import "../../user-profile/components/P2PStatusCell.js";
import "../../user-profile/components/UserDetailsWDBalance.js";
import "../../user-profile/components/ReferralLinkButton.js";
import "../../user-profile/components/PlayerIdAutocomplete.js";
import { BulkActionKey } from "../types.js";
const localized = defineMessages({
  bulkSummaryValueLock: {
    id: "bulkSummaryValueLock",
    defaultMessage: "Lock All"
  },
  bulkSummaryValueUnlock: {
    id: "bulkSummaryValueUnlock",
    defaultMessage: "Unlock All"
  },
  bulkSummaryValueGlobal: {
    id: "bulkSummaryValueGlobal",
    defaultMessage: "Global"
  }
});
const BulkSummaryValueText = ({ actionValue }) => {
  return /* @__PURE__ */ React.createElement(LocalizedText, { label: actionValue });
};
const BulkSummaryChipValue = ({ actionValue }) => {
  return /* @__PURE__ */ React.createElement(MemoizedDefaultChip, { value: actionValue, variant: ChipVariant.Blue, type: ChipType.Status });
};
const BulkSummaryKYCValue = ({ actionValue }) => {
  return /* @__PURE__ */ React.createElement(MemoizedChip, { value: actionValue, chipName: BulkAccountVerificationStatus });
};
function BulkLockWithReasonValue({ actionValue }) {
  const { formatMessage } = useIntl();
  const { isLocked, reason } = actionValue;
  const lockedLabel = formatMessage(isLocked ? localized.bulkSummaryValueLock : localized.bulkSummaryValueUnlock);
  const reasonLabel = isLocked && reason ? `(${lockReasonOptions[reason] ? formatMessage(lockReasonOptions[reason]) : reason})` : "";
  return /* @__PURE__ */ React.createElement(BulkSummaryValueText, { actionValue: `${lockedLabel} ${reasonLabel}` });
}
const BulkP2PSettings = ({ actionValue }) => {
  const value = actionValue;
  const isGlobal = value.p2p_settings_type !== void 0 && value.p2p_settings_type === "Global" || value.p2p_settings_type === void 0 && !value.is_personal_p2p_settings_applied;
  return /* @__PURE__ */ React.createElement(
    BulkSummaryValueText,
    {
      actionValue: isGlobal ? localized.bulkSummaryValueGlobal : value?.is_p2p_locked ? localized.bulkSummaryValueLock : localized.bulkSummaryValueUnlock
    }
  );
};
const useBulkActionSummaryValue = ({ actionKey, actionValue }) => {
  const mapping = {
    [BulkActionKey.Message]: /* @__PURE__ */ React.createElement(BulkSummaryChipValue, { actionValue: "1" }),
    [BulkActionKey.NotesAndAttachments]: /* @__PURE__ */ React.createElement(BulkSummaryChipValue, { actionValue: "1" }),
    [BulkActionKey.SecurityCasesAdd]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.SecurityCasesRemove]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.SecurityCasesUpdate]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.AccountLock]: /* @__PURE__ */ React.createElement(BulkLockWithReasonValue, { actionValue }),
    [BulkActionKey.DepositLock]: /* @__PURE__ */ React.createElement(BulkLockWithReasonValue, { actionValue }),
    [BulkActionKey.WithdrawalLock]: /* @__PURE__ */ React.createElement(BulkLockWithReasonValue, { actionValue }),
    [BulkActionKey.LobbyLock]: /* @__PURE__ */ React.createElement(BulkLockWithReasonValue, { actionValue }),
    [BulkActionKey.CasinoLock]: /* @__PURE__ */ React.createElement(
      BulkSummaryValueText,
      {
        actionValue: actionValue === FeatureAccessStatus.Locked ? localized.bulkSummaryValueLock : localized.bulkSummaryValueUnlock
      }
    ),
    [BulkActionKey.SportsbookLock]: /* @__PURE__ */ React.createElement(
      BulkSummaryValueText,
      {
        actionValue: actionValue === FeatureAccessStatus.Locked ? localized.bulkSummaryValueLock : localized.bulkSummaryValueUnlock
      }
    ),
    [BulkActionKey.ManualTriggerMTTTicket]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTriggerDepositCashMatch]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTriggerDepositCashMatchAmount]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTriggerDepositCashMatchCode]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTriggerImmediateCashBonus]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTriggerCasinoCoinBonus]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualTransactions]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.SecurityCases]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.SecurityCasesAll]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.AddUserLabel]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.RemoveUserLabel]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.P2PTransfer]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.KYCReject]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.InitiatePaymentKYC]: /* @__PURE__ */ React.createElement(BulkSummaryKYCValue, { actionValue: AccountVerificationStatus.InitPaymentKyc }),
    [BulkActionKey.KYCAssign]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.TransactionAssign]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.P2PSettings]: /* @__PURE__ */ React.createElement(BulkP2PSettings, { actionValue }),
    [BulkActionKey.CreditReqeusts]: /* @__PURE__ */ React.createElement(React.Fragment, null),
    [BulkActionKey.ManualCredit]: /* @__PURE__ */ React.createElement(React.Fragment, null)
  };
  return actionValue !== null && actionValue !== void 0 ? mapping[actionKey] ?? /* @__PURE__ */ React.createElement(BulkSummaryValueText, { actionValue: actionValue?.toString() }) : /* @__PURE__ */ React.createElement(React.Fragment, null);
};
export {
  useBulkActionSummaryValue
};
//# sourceMappingURL=BulkSummaryStepSummaryValue.js.map
